
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ru",
  "ja",
  "id",
  "ar",
  "cn",
  "de",
  "es",
  "fr",
  "it",
  "kr",
  "nl",
  "pt",
  "tr",
  "zh"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_index_46ts_07901d59",
      load: () => import("#nuxt-i18n/07901d59" /* webpackChunkName: "locale_index_46ts_07901d59" */),
      cache: false
    }
  ],
  ru: [
    {
      key: "locale_index_46ts_c65d2dd7",
      load: () => import("#nuxt-i18n/c65d2dd7" /* webpackChunkName: "locale_index_46ts_c65d2dd7" */),
      cache: false
    }
  ],
  ja: [
    {
      key: "locale_index_46ts_ffb68835",
      load: () => import("#nuxt-i18n/ffb68835" /* webpackChunkName: "locale_index_46ts_ffb68835" */),
      cache: false
    }
  ],
  id: [
    {
      key: "locale_index_46ts_46b17531",
      load: () => import("#nuxt-i18n/46b17531" /* webpackChunkName: "locale_index_46ts_46b17531" */),
      cache: false
    }
  ],
  ar: [
    {
      key: "locale_index_46ts_2331b945",
      load: () => import("#nuxt-i18n/2331b945" /* webpackChunkName: "locale_index_46ts_2331b945" */),
      cache: false
    }
  ],
  cn: [
    {
      key: "locale_index_46ts_b3b12193",
      load: () => import("#nuxt-i18n/b3b12193" /* webpackChunkName: "locale_index_46ts_b3b12193" */),
      cache: false
    }
  ],
  de: [
    {
      key: "locale_index_46ts_7d332cdc",
      load: () => import("#nuxt-i18n/7d332cdc" /* webpackChunkName: "locale_index_46ts_7d332cdc" */),
      cache: false
    }
  ],
  es: [
    {
      key: "locale_index_46ts_01e5bb3d",
      load: () => import("#nuxt-i18n/01e5bb3d" /* webpackChunkName: "locale_index_46ts_01e5bb3d" */),
      cache: false
    }
  ],
  fr: [
    {
      key: "locale_index_46ts_a6ce66cd",
      load: () => import("#nuxt-i18n/a6ce66cd" /* webpackChunkName: "locale_index_46ts_a6ce66cd" */),
      cache: false
    }
  ],
  it: [
    {
      key: "locale_index_46ts_c04cc487",
      load: () => import("#nuxt-i18n/c04cc487" /* webpackChunkName: "locale_index_46ts_c04cc487" */),
      cache: false
    }
  ],
  kr: [
    {
      key: "locale_index_46ts_40a999bb",
      load: () => import("#nuxt-i18n/40a999bb" /* webpackChunkName: "locale_index_46ts_40a999bb" */),
      cache: false
    }
  ],
  nl: [
    {
      key: "locale_index_46ts_dc06cb2b",
      load: () => import("#nuxt-i18n/dc06cb2b" /* webpackChunkName: "locale_index_46ts_dc06cb2b" */),
      cache: false
    }
  ],
  pt: [
    {
      key: "locale_index_46ts_db9d6a1d",
      load: () => import("#nuxt-i18n/db9d6a1d" /* webpackChunkName: "locale_index_46ts_db9d6a1d" */),
      cache: false
    }
  ],
  tr: [
    {
      key: "locale_index_46ts_f9218ba0",
      load: () => import("#nuxt-i18n/f9218ba0" /* webpackChunkName: "locale_index_46ts_f9218ba0" */),
      cache: false
    }
  ],
  zh: [
    {
      key: "locale_index_46ts_15fe605e",
      load: () => import("#nuxt-i18n/15fe605e" /* webpackChunkName: "locale_index_46ts_15fe605e" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en",
      name: "English",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/en/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      language: "ru",
      name: "Russian",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/ru/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "ja",
      language: "ja",
      name: "Japanese",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/ja/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "id",
      language: "id",
      name: "Indonesian",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/id/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "ar",
      language: "ar",
      name: "Arabic",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/ar/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "cn",
      language: "zh-TW",
      name: "China",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/cn/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      language: "de",
      name: "German",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/de/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es",
      name: "Spanish",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/es/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr",
      name: "French",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/fr/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      language: "it",
      name: "Italian",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/it/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "kr",
      language: "ko",
      name: "Korea",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/kr/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      language: "nl",
      name: "Dutch",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/nl/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      language: "pt",
      name: "Portuguese",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/pt/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      language: "tr",
      name: "Turkey",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/tr/index.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      language: "zh-CN",
      name: "简体中文",
      files: [
        {
          path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/zh/index.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "../i18n/locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "NUXT_LOCALE",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://lip-sync.ai",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en",
    name: "English",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/en/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    language: "ru",
    name: "Russian",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/ru/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    language: "ja",
    name: "Japanese",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/ja/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "id",
    language: "id",
    name: "Indonesian",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/id/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    language: "ar",
    name: "Arabic",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/ar/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "cn",
    language: "zh-TW",
    name: "China",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/cn/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    language: "de",
    name: "German",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/de/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es",
    name: "Spanish",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/es/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr",
    name: "French",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/fr/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    language: "it",
    name: "Italian",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/it/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "kr",
    language: "ko",
    name: "Korea",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/kr/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    language: "nl",
    name: "Dutch",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/nl/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    language: "pt",
    name: "Portuguese",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/pt/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    language: "tr",
    name: "Turkey",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/tr/index.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    language: "zh-CN",
    name: "简体中文",
    files: [
      {
        path: "/data/root-data/TG/lip-sync/master/lip-sync/i18n/locales/zh/index.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/